import React, { useEffect, useState } from "react";

const KEY = "gp_cookie_ok_at";
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const ts = parseInt(localStorage.getItem(KEY) || "0", 10);
      if (!ts || Date.now() - ts > WEEK_MS) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch {}
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-5 left-5 z-[60] bg-white rounded-2xl shadow-[0_15px_45px_rgba(0,0,0,0.2)] p-5 max-w-[320px] border border-gray-100" data-testid="cookie-banner">
      <p className="text-[#16243b] font-semibold text-[1rem]">This website uses cookies</p>
      <a href="/#" className="text-[#2ec9c9] text-[0.85rem] hover:underline">Read our cookie policy</a>
      <div className="mt-3">
        <button onClick={accept} data-testid="cookie-ok-btn" className="gp-btn-teal rounded-full px-8 py-2 text-[0.9rem] font-medium">Ok</button>
      </div>
    </div>
  );
}
